<div class="graph-container">
    <!-- Loading Overlay -->
    <div *ngIf="isLoading" class="loading-overlay">
        <div class="spinner"></div>
        <span>Loading charts...</span>
    </div>

    <select class="filter-select select-cycle py-0 px-3 mb-3 inline-block" (change)="onCycleChange($event)">
        <option *ngFor="let cycle of farmCycles; let i = index" [value]="cycle.id" [selected]="i === 0">
            {{ cycle.name }}
        </option>
    </select>


    <div class="tile-container">
        <canvas id="chickGrowthGraph"></canvas>
    </div>
</div>